// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Chart.js wrappers ======
// Sostituiscono i bar-chart custom in dashboard.js per "Perimetri coperti" e "Clienti per CPL".

import Chart from 'chart.js/auto';
globalThis.Chart = Chart;

const _charts = {};

function chartColors() {
  const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
  return {
    grid: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(15,23,42,0.07)',
    text: isDark ? '#cbd5e1' : '#1a2238',
    palette: [
      '#2563eb',
      '#7c3aed',
      '#16a34a',
      '#d97706',
      '#dc2626',
      '#0891b2',
      '#db2777',
      '#65a30d',
      '#9333ea',
      '#0284c7',
      '#ea580c',
      '#4f46e5'
    ]
  };
}

function renderChartBar(canvasId, data, opts = {}) {
  if (typeof Chart === 'undefined') return;
  const canvas = document.getElementById(canvasId);
  if (!canvas) return;
  if (_charts[canvasId]) {
    _charts[canvasId].destroy();
  }
  const c = chartColors();
  const labels = data.map((d) => d.label);
  const values = data.map((d) => d.value);
  const horizontal = opts.horizontal !== false;

  _charts[canvasId] = new Chart(canvas, {
    type: 'bar',
    data: {
      labels,
      datasets: [
        {
          label: opts.label || 'Conteggio',
          data: values,
          backgroundColor: labels.map((_, i) => c.palette[i % c.palette.length] + 'cc'),
          borderColor: labels.map((_, i) => c.palette[i % c.palette.length]),
          borderWidth: 1,
          borderRadius: 4
        }
      ]
    },
    options: {
      indexAxis: horizontal ? 'y' : 'x',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: c.text,
          titleColor: '#fff',
          bodyColor: '#fff'
        }
      },
      scales: {
        x: { grid: { color: c.grid }, ticks: { color: c.text, font: { size: 11 } } },
        y: { grid: { color: c.grid }, ticks: { color: c.text, font: { size: 11 } } }
      }
    }
  });
}

// Line chart multi-serie (usato dal trend storico del cruscotto Controllo area).
// data: { labels: string[], series: [{ label, data: number[] }] }
function renderChartLine(canvasId, data, opts = {}) {
  if (typeof Chart === 'undefined') return;
  const canvas = document.getElementById(canvasId);
  if (!canvas) return;
  if (_charts[canvasId]) _charts[canvasId].destroy();
  const c = chartColors();
  _charts[canvasId] = new Chart(canvas, {
    type: 'line',
    data: {
      labels: data.labels || [],
      datasets: (data.series || []).map((s, i) => ({
        label: s.label,
        data: s.data,
        borderColor: c.palette[i % c.palette.length],
        backgroundColor: c.palette[i % c.palette.length] + '22',
        borderWidth: 2,
        tension: 0.3,
        fill: !!opts.fill,
        pointRadius: 2,
        pointHoverRadius: 4
      }))
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: {
          display: (data.series || []).length > 1,
          labels: { color: c.text, font: { size: 11 }, boxWidth: 12 }
        },
        tooltip: { backgroundColor: c.text, titleColor: '#fff', bodyColor: '#fff' }
      },
      scales: {
        x: { grid: { color: c.grid }, ticks: { color: c.text, font: { size: 10 } } },
        y: {
          beginAtZero: true,
          grid: { color: c.grid },
          ticks: { color: c.text, font: { size: 10 }, precision: 0 }
        }
      }
    }
  });
}

function refreshCharts() {
  // Forza ridisegno con la nuova palette tema
  if (typeof globalThis.renderDashboard === 'function') globalThis.renderDashboard();
  if (
    typeof globalThis.renderControlloArea === 'function' &&
    document.getElementById('controlloRoot')
  ) {
    globalThis.renderControlloArea('controlloRoot');
  }
}

Object.assign(globalThis, { renderChartBar, renderChartLine, refreshCharts });
export {};
